import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { reduce } from "et3-type-guards";
import { useState } from "react";

import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Image from "../../core/et3-Image";
import Et3Text from "../../core/et3-text";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import {
  HEADER_ITEM_ACTIVE_BACKGROUND,
  HEADER_ITEM_HOVER_BACKGROUND,
  HEADER_PROFILE_AVATAR_SIZE,
  HEADER_PROFILE_CHEVRON_SIZE,
  HEADER_PROFILE_FONT_SIZE,
  HEADER_PROFILE_GAP,
  HEADER_PROFILE_HEIGHT,
  HEADER_PROFILE_PADDING_X,
  HEADER_PROFILE_RADIUS,
  HEADER_TRANSITION
} from "./header-constants";

const EMAIL_SEPARATOR = "@";

const HeaderProfile = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const [isHovered, setIsHovered] = useState(false);
  const user = getCorePersonalStore().user.get();
  const username = reduce(() => user.username, "");
  const displayName = reduce(
    () => username.split(EMAIL_SEPARATOR)[0],
    username
  );
  const userImageName = getCorePersonalStore().userPofilePic.get();
  const isOpen = getCoreUIStore().isProfileDropdownVisible.get();

  const backgroundColor = (() => {
    switch (true) {
      case isOpen:
        return HEADER_ITEM_ACTIVE_BACKGROUND;
      case isHovered:
        return HEADER_ITEM_HOVER_BACKGROUND;
      default:
        return colors.all.transparent;
    }
  })();

  return (
    <button
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => getCoreUIStore().toggleProfileDropdown()}
      style={{
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        border: 0,
        cursor: "pointer",
        backgroundColor,
        height: HEADER_PROFILE_HEIGHT * unitY,
        borderRadius: HEADER_PROFILE_RADIUS * unitX,
        paddingLeft: HEADER_PROFILE_PADDING_X * unitX,
        paddingRight: HEADER_PROFILE_PADDING_X * unitX,
        gap: HEADER_PROFILE_GAP * unitX,
        transition: HEADER_TRANSITION,
        whiteSpace: "nowrap"
      }}
    >
      <Et3Image
        type="LOCAL"
        alt={i18n.get("ALKHATTABA_ADMIN")}
        imageName={userImageName}
        size={HEADER_PROFILE_AVATAR_SIZE}
        onClick={() => {}}
        style={{
          borderRadius: HEADER_PROFILE_AVATAR_SIZE * unitX,
          flexShrink: 0
        }}
      />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={HEADER_PROFILE_FONT_SIZE}
        text={displayName}
        isSpan={false}
        color={colors.all.maastrichtBlue}
        style={{ margin: 0, whiteSpace: "nowrap" }}
      />
      <FontAwesomeIcon
        icon={isOpen ? faChevronUp : faChevronDown}
        color={colors.all.dimGray}
        style={{
          width: HEADER_PROFILE_CHEVRON_SIZE * unitX,
          height: HEADER_PROFILE_CHEVRON_SIZE * unitY,
          flexShrink: 0
        }}
      />
    </button>
  );
});
export default HeaderProfile;
